/**
 * Format a date as "Today at HH:MM AM/PM" or "Yesterday at HH:MM AM/PM" or "DD.MM.YYYY at HH:MM AM/PM"
 */
export const formatLastOpenedDate = (date: Date | null): string => {
    if (!date) {
        return '';
    }

    const now = new Date();
    const isToday = 
        date.getDate() === now.getDate() &&
        date.getMonth() === now.getMonth() &&
        date.getFullYear() === now.getFullYear();

    const yesterday = new Date(now);
    yesterday.setDate(yesterday.getDate() - 1);
    const isYesterday =
        date.getDate() === yesterday.getDate() &&
        date.getMonth() === yesterday.getMonth() &&
        date.getFullYear() === yesterday.getFullYear();

    const hours = date.getHours();
    const minutes = date.getMinutes();
    const ampm = hours >= 12 ? 'PM' : 'AM';
    const displayHours = hours % 12 || 12;
    const displayMinutes = minutes.toString().padStart(2, '0');
    const timeString = `${displayHours}:${displayMinutes} ${ampm}`;

    if (isToday) {
        return `Heute um ${timeString}`;
    } else if (isYesterday) {
        return `Gestern um ${timeString}`;
    } else {
        const day = date.getDate().toString().padStart(2, '0');
        const month = (date.getMonth() + 1).toString().padStart(2, '0');
        const year = date.getFullYear();
        return `${day}.${month}.${year} um ${timeString}`;
    }
};
